import { memo, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useUtils } from "../../services/utilsProvider";
import { Icon } from "../../ui";
import {  usePublicHoliday } from "./provider";
import PublicHolidayForm from "./PublicHolidayForm";

const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 0;
    svg {
      margin: 0 20px 0 10px;
    }
  }
`;

function EditPublicHoliday() {
  const params = useParams();
  const navigate = useNavigate();
  const { notify } = useUtils();
  const [holi , setHoli] = useState(null)
  const {
    state: { selected: holiday },
    fetchOne,
    dispatch,
  } = usePublicHoliday();

  useEffect(() => {
    fetchOne(params.id);
    return () => dispatch({ type: "set_selected", payload: null });
  }, [params.id, fetchOne, dispatch]);

  const handleSuccess = () => {
    navigate(-1);
    notify("Changes saved successfully");
  };


  useEffect(()=>{
    setHoli(holiday)
  },[holiday , window.location.pathname])

  console.log();

  if (!holiday) return;

  
  return (
    <div id="edit-holiday">
      <Grid>
        <h2 style={{ marginTop: "0" }}>Edit public Holiday</h2>
        <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          <span>Back</span>
          <Icon name="arrowLeft" />
        </div>
      </Grid>
      <PublicHolidayForm holiday={holiday} handleSuccess={handleSuccess} />
    </div>
  );
}

export default memo(EditPublicHoliday);
